import { Breadcrumb } from '@components/ContentHeader'
import { toUserRoute, userPath } from '@src/common/appConfig'
import messages from '@src/user/utils/messages'

export const BREADCRUMBS: Breadcrumb[] = [
  { title: messages.agency, route: toUserRoute(userPath.agencyList.list) },
]
